module.exports = __webpack_public_path__ + "img/product_mobile2.5ca35e51.jpg";